<div class="em-pager">
  <span class="em-pager__info" data-testid="pager-range">{{ rangeLabel() }}</span>

  <nav class="em-pager__nav" aria-label="Pages">
    <button
      type="button"
      class="em-pager__btn"
      [disabled]="current() <= 1"
      aria-label="Previous page"
      (click)="goTo(current() - 1)"
    >
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    @for (slot of slots(); track $index) {
      @if (slot === null) {
        <span class="em-pager__gap" aria-hidden="true">…</span>
      } @else {
        <button
          type="button"
          class="em-pager__btn em-pager__btn--page"
          [class.em-pager__btn--current]="slot === current()"
          [attr.aria-current]="slot === current() ? 'page' : null"
          (click)="goTo(slot)"
        >
          {{ slot }}
        </button>
      }
    }

    <button
      type="button"
      class="em-pager__btn"
      [disabled]="current() >= totalPages()"
      aria-label="Next page"
      (click)="goTo(current() + 1)"
    >
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </nav>

  <label class="em-pager__per">
    Items per page:
    <select class="em-pager__select" (change)="onLimitSelect($any($event.target).value)">
      @for (option of limitOptions(); track option) {
        <option [value]="option" [selected]="option === meta().limit">{{ option }}</option>
      }
    </select>
  </label>
</div>
